import { ParcelStockoutCommand } from "./parcel-stockout-command";
import { httpPost } from "../../../network/fetch";
import { IParcelStockoutResponse, ParcelStockoutResponse } from "../../../../front-office/model/parcel-stockout-response";
import { parcelsService } from "../../../../front-office/services/parcels";

export const ParcelStockoutHandler = async (command: ParcelStockoutCommand) => {
    const createdStockout = new ParcelStockoutResponse(await httpPost<IParcelStockoutResponse>({
        url: `/stocks/${command.parcel.operationCode}/batch/${command.parcel.batchId}/stockout-parcels`,
        data: { parcels: [{
            parcelId: command.parcel.parcelId,
            products: Array.from(command.productsList).map(([productId, quantity]) => ({
                productId, quantity,
            }))}]},
    }));

    if (createdStockout.error) {
        throw new Error(createdStockout.error);
    }

    const updatedParcel = await parcelsService.loadParcelByParcelId(command.parcel.operationCode,
        command.parcel.batchId, command.parcel.parcelId);
    if (updatedParcel.status === "Cancelled") {
        command.parcel.cancel();
    } else {
        command.parcel.updateParcelDetail(updatedParcel.details, true);
    }

    return true;
};
